import { render } from "./long-insure-add-subtract.vue?vue&type=template&id=c7bf044c&scoped=true&ts=true"
import script from "./long-insure-add-subtract.vue?vue&type=script&lang=ts"
export * from "./long-insure-add-subtract.vue?vue&type=script&lang=ts"

import "./long-insure-add-subtract.vue?vue&type=style&index=0&id=c7bf044c&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7bf044c"]])

export default __exports__